<div class="overlay">
  <div class="popup">
    <div class="title-bar">Ownership Change</div>

    <div class="content">
      <p>{{ data?.message }}</p>

      <div class="actions">
        <button class="allow-btn" [disabled]="loading" (click)="action.emit('ACCEPT')">
          <span *ngIf="!(loading && selectedAction === 'ACCEPT')"> Allow </span>

          <span *ngIf="loading && selectedAction === 'ACCEPT'" class="btn-loader"> </span>
        </button>

        <button class="refuse-btn" [disabled]="loading" (click)="action.emit('REJECT')">
          <span *ngIf="!(loading && selectedAction === 'REJECT')"> Refuse </span>

          <span *ngIf="loading && selectedAction === 'REJECT'" class="btn-loader"> </span>
        </button>
      </div>

      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</div>
